import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Phone, X } from "lucide-react";
import { PHONE_TEL } from "@/lib/site";

export const StickyCallBar = () => {
  const [show, setShow] = useState(false);
  const [closed, setClosed] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && !closed && (
        <motion.div data-testid="sticky-call-bar" initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 28 }}
          className="fixed inset-x-2 bottom-2 z-40 mx-auto flex max-w-[680px] items-center gap-3 rounded-2xl bg-ink p-3 pl-4 text-white shadow-2xl sm:bottom-4 sm:pl-6">
          <Phone className="h-5 w-5 shrink-0 text-coral" />
          <div className="min-w-0 flex-1 leading-tight">
            <p className="truncate font-display text-sm font-bold">Talk to a real expert</p>
            <p className="truncate text-xs text-white/75">Your next journey starts here</p>
          </div>
          <a href={PHONE_TEL} data-testid="sticky-call-btn" className="flex items-center gap-2 rounded-xl bg-coral px-4 py-2.5 text-sm font-bold transition-colors hover:bg-coral-dark">
            <Phone className="h-4 w-4" /> <span className="hidden sm:inline">Call Now</span><span className="sm:hidden">Call</span>
          </a>
          <button onClick={() => setClosed(true)} aria-label="Close" data-testid="sticky-call-close" className="p-1 text-white/70 hover:text-white"><X className="h-4 w-4" /></button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
